import { useFeatureFlag } from '@moda/portal-stanchions';
import { useState } from 'react';
import { useIsCloudFrontViewerCountryUS } from '../../../hooks/useIsCloudfrontViewerCountryUS';

export const useEmailSignupPhoneNumber = () => {
  const showPhoneNumberInput = useFeatureFlag('allow-phone-number', [
    { default: false },
    { if: true, then: true }
  ]);

  const isCloudFrontViewerCountryUS = useIsCloudFrontViewerCountryUS();

  const enabled = isCloudFrontViewerCountryUS && showPhoneNumberInput;

  const [phone, setPhone] = useState<string>('');

  return { phone, setPhone, enabled };
};
